import { ContentBox } from "@msuite/ui/app-shell";
import { BlankSlate } from "@msuite/ui/blank-slate";

export function Tasks() {
	/** Render */
	return (
		<ContentBox>
			<BlankSlate />
		</ContentBox>
	);
}
